import { LogoutService } from './../../login/services/logout.service';
import { LoginWebService } from './../../login-web/services/login-web.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root',
})
export class EmpleadocompraGuard implements CanActivate {
  constructor(
    private router: Router,
    private _login: LoginWebService,
    private _logout: LogoutService
  ) {}

  canActivate() {
    const perms = localStorage.getItem('uni_perms');
    // Si el usuario tiene permisos
    if (isNullOrUndefined(perms)) {
      this.router.navigate(['']);
      return false;
    } else {
      // Array de permisos guardados en localStorage
      const userPermissions = this._login.getUserRoles();
      // Array de permisos
      const empleadoPerms = Object.values(this._login.rolesMap);
      // Si encuentra al menos 1 de los permisos, manda true
      const foundEmpleado = empleadoPerms.some(
        (r) => userPermissions.indexOf(r) >= 0
      );
      // En el caso de haber permisos retorna true para dejarlo pasar
      if (foundEmpleado) {
        return true;
      } else {
        this._logout.logOut();
        return false;
      }
    }
  }
}
